var _path, _path2, _g, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoApiKeyCreated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 97.3333C76.1416 97.3333 97.3334 76.1414 97.3334 50C97.3334 23.8585 76.1416 2.66663 50.0001 2.66663C23.8586 2.66663 2.66675 23.8585 2.66675 50C2.66675 76.1414 23.8586 97.3333 50.0001 97.3333Z",
    fill: "#e5fff2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7602 77.3934C70.7234 77.3934 78.8002 69.3166 78.8002 59.3534C78.8002 49.3901 70.7234 41.3134 60.7602 41.3134C50.797 41.3134 42.7202 49.3901 42.7202 59.3534C42.7202 69.3166 50.797 77.3934 60.7602 77.3934Z",
    fill: "#e5fff2",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0469 34.6866V45.2733H28.2869V53.74",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9935 29.5133H28.0535V38.4533H36.9935V29.5133Z",
    fill: "white",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8602 29.5133H57.9202V38.4533H66.8602V29.5133Z",
    fill: "white",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9935 59.1466H28.0535V68.0866H36.9935V59.1466Z",
    fill: "white",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1335 50.4933H33.9669C33.6869 50.4933 33.4602 50.2666 33.4602 49.9866V49.3066C33.4602 49.0266 33.6869 48.7999 33.9669 48.7999H38.1335C38.4135 48.7999 38.6402 49.0266 38.6402 49.3066V49.9866C38.6335 50.2666 38.4069 50.4933 38.1335 50.4933Z",
    fill: "white",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1602 29.5133H50.8668V40.0933",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9401 63.5734H61.4868V71.0267H68.9401V63.5734Z",
    fill: "white",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4869 53.3734V48.8667H55.4069V54.7467H49.9136V60.8267H55.6002V69.4534",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1135 58.08H68.9335V47.6866",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7334 70.6L90.6134 86.4866",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApiKeyCreated);
export default __webpack_public_path__ + "static/media/noApiKeyCreated.058b726b0640d1405f4874d5dd92f0bd.svg";
export { ForwardRef as ReactComponent };